"use strict";
import { defineComponent } from "vue";
import { mountVueApp } from "../vue-app";
export const NavVueComponent = defineComponent({
  name: "NavVueComponent",
  data() {
    return {
      expandedDropdown: null,
      navigationExpanded: false
    };
  },
  mounted() {
    document.addEventListener("click", this.handleDocumentClick);
  },
  beforeUnmount() {
    document.removeEventListener("click", this.handleDocumentClick);
  },
  methods: {
    handleDocumentClick(event) {
      if (event.target instanceof Node && this.$el.contains(event.target)) {
        return;
      }
      this.navigationExpanded = false;
      this.expandedDropdown = null;
    },
    isActive(viewLocations) {
      const currentPath = window.location.pathname.toLowerCase();
      return viewLocations.some(
        (path) => path.toLowerCase() === currentPath
      );
    },
    toggleDropdown(dropdown) {
      this.expandedDropdown = this.expandedDropdown === dropdown ? null : dropdown;
    },
    toggleNavigation() {
      this.navigationExpanded = !this.navigationExpanded;
    }
  }
});
export function initialiseNavVueComponent() {
  return mountVueApp(NavVueComponent, "#app-nav");
}
if (document.querySelector("#app-nav")) {
  initialiseNavVueComponent();
}
